import { AppButton } from 'components';
import usePlan from 'hooks/API/GET/usePlan';
import ManagePlan from './ManagePlan';
import useManagePlan from 'hooks/API/useManagePlan';
import useToaster from 'hooks/useToaster';
import { useState } from 'react';
import BasicDelete from 'components/molecules/Modal/Delete/BasicDelete';
import useDeletePlan from 'hooks/API/DELETE/useDeletePlan';
import TablePaginate from 'components/Paginate';
import usePaginateDefaults from 'hooks/usePaginateDefaults';
import DOMPurify from 'dompurify';
import * as AppPics from 'assets/images';
function MainPlan() {
  const [params, setParams] = usePaginateDefaults();
  const [selectedPlan, handleSelectedPlan] = useState({});
  const [deleteSModal, handleDeleteSModal] = useState({ show: false, data: {} });
  const { isLoading, isError, data } = usePlan({ enabled: true, configs: { params } });
  const { isLoading: esUpdating, mutate, isError: esError } = useManagePlan();
  const deleteAPIObject = useDeletePlan();
  const { meta: { page, total } = {} } = data?.data ?? {};

  useToaster(esUpdating, { type: esError ? 'error' : 'success' });

  function manageEs(data) {
    if (esUpdating) return;

    mutate(data);
    closeSModal();
  }

  function closeSModal() {
    handleDeleteSModal({ show: false, data: {} });
    handleSelectedPlan({});
  }

  return (
    <>
      <BasicDelete
        open={deleteSModal.show}
        closeModal={closeSModal}
        Header="Delete Plan"
        handleConfirmation={() => {
          if (deleteAPIObject.isLoading) return;

          deleteAPIObject.mutate(deleteSModal?.data?._id);
          closeSModal();
        }}
      />
      <div className="mainWraper">
        <div className="container-fluid outerborder">
          <ManagePlan
            save={manageEs}
            selectedItem={selectedPlan}
            handleSelectedItem={handleSelectedPlan}
          />
          <div className="tableWrap">
            <div className="table-responsive">
              <table className="table tableWrap__table">
                <thead className="thead-light __appTheadColor">
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col" className="w20">
                      Plan Name
                    </th>
                    <th scope="col" className="w20">
                      Plan Description
                    </th>
                    <th scope="col" className="w20">
                      Available Module
                    </th>
                    <th scope="col" className="w20">
                      Status
                    </th>
                    <th scope="col" className="align-center">
                      Action
                    </th>
                  </tr>
                </thead>
                {isLoading ? (
                  <tbody>
                    <tr>
                      <td>Loading...</td>
                    </tr>
                  </tbody>
                ) : isError ? (
                  <tbody>
                    <tr>
                      <td>Failed to load data</td>
                    </tr>
                  </tbody>
                ) : data?.data?.result?.length > 0 ? (
                  <tbody>
                    {data?.data?.result?.map?.((result, index) => {
                      return (
                        <tr key={result._id}>
                          <th scope="row">{index + 1}</th>
                          <td>{result.name}</td>
                          <td>{DOMPurify.sanitize(result.description)}</td>
                          <td>{result?.modules?.map((x) => x.name)?.join(', ')}</td>
                          <td>{result.status}</td>
                          <td className="align-center">
                            <AppButton
                              className="actions-icons mx-2 text-primary"
                              onClick={() => {
                                handleSelectedPlan(result);
                              }}
                              title="Edit"
                            >
                              <img src={AppPics.EditSvg} alt="edit this option" />
                            </AppButton>

                            <AppButton
                              className="actions-icons mx-2 text-danger"
                              onClick={() => {
                                handleDeleteSModal({ show: true, data: result });
                              }}
                              title="Delete"
                            >
                              <img src={AppPics.DeleteSvg} alt="delete this option" />
                            </AppButton>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                ) : (
                  <tbody>
                    <tr>
                      <td colSpan="5">No records found</td>
                    </tr>
                  </tbody>
                )}
              </table>
            </div>
          </div>
          <TablePaginate
            maxCount={total}
            currentPage={page}
            defaultLimit={params.limit}
            setPage={(page) => setParams((x) => ({ ...x, page }))}
            handleChange={(limit) => setParams((x) => ({ ...x, page: 0, limit }))}
          />
        </div>
      </div>
    </>
  );
}

export default MainPlan;
